// Admin inquiries area. Two tabs over the same workspace:
//   - Inquiries: submitted pricing requests (the full funnel output).
//   - Form submissions: every initial contact-gate submission (passed or
//      for following up with non-finishers and spot-checking blocks.blocked)
import { useState } from 'react';
import {
  Box, Typography, Tabs, Tab,
} from '@mui/material';
import InquiriesTable from '../../components/admin/inquiries/InquiriesTable.jsx';
import ContactSubmissionsTable from '../../components/admin/inquiries/ContactSubmissionsTable.jsx';

const TABS = [
  { label: 'Inquiries', description: 'Submitted pricing requests from the public intake form.' },
  { label: 'Form submissions', description: 'Every initial contact-form submission, whether it passed or was blocked.' },
];

const AdminInquiriesPage = () => {
  const [tab, setTab] = useState(0);

  return (
    <Box>
      <Box sx={{ mb: 2 }}>
        <Typography variant="h4" component="h1" sx={{ fontWeight: 700 }}>
          Inquiries
        </Typography>
        <Typography variant="body2" color="text.secondary">
          {TABS[tab].description}
        </Typography>
      </Box>

      <Tabs
        value={tab}
        onChange={(_e, next) => setTab(next)}
        sx={{ mb: 2, borderBottom: 1, borderColor: 'divider' }}
        aria-label="Inquiries views"
      >
        {TABS.map((t) => (
          <Tab key={t.label} label={t.label} />
        ))}
      </Tabs>

      {tab === 0 ? <InquiriesTable /> : <ContactSubmissionsTable />}
    </Box>
  );
};

export default AdminInquiriesPage;
